import React, { useCallback, useEffect, useRef, useState } from 'react';
import api from '../../utils/api';

const TOKEN_KEY = 'kioskStationToken';
const META_KEY = 'kioskStationMeta';

const styles = `
:root{
  --ink:#14261F;--primary:#1E5C46;--accent:#D9A441;--accent-soft:#FBF3E2;
  --bg:#F6F8F6;--surface:#FFFFFF;--border:#E3E8E3;--muted:#66736C;
  --danger:#B4442C;--danger-soft:#FBEDE9;--ok:#1E5C46;--ok-soft:#E7F0EC;
  --font-display:'Archivo',sans-serif;--font-body:'Inter',sans-serif;
}
.kiosk-root{font-family:var(--font-body);background:var(--ink);color:var(--ink);min-height:100vh;-webkit-font-smoothing:antialiased}
.kiosk-root h1,.kiosk-root h2,.kiosk-root h3{font-family:var(--font-display);letter-spacing:-.01em}
.kiosk-root button{font-family:inherit;cursor:pointer}
.kiosk-root :focus-visible{outline:3px solid var(--accent);outline-offset:2px}
.stationbar{position:fixed;top:0;left:0;right:0;height:52px;background:#0E1A15;color:#C7D2CB;display:flex;align-items:center;gap:16px;padding:0 22px;font-size:14px;z-index:30;border-bottom:1px solid rgba(255,255,255,.08)}
.stationbar .wm{font-family:var(--font-display);font-weight:700;letter-spacing:.14em;color:#F3F6F4}
.stationbar .wm span{color:var(--accent)}
.stationbar .pill{background:rgba(217,164,65,.15);color:var(--accent);padding:4px 11px;border-radius:99px;font-weight:600;font-size:12.5px;display:inline-flex;gap:7px;align-items:center}
.stationbar .pill .dot{width:7px;height:7px;border-radius:50%;background:var(--accent)}
.stationbar .right{margin-left:auto;display:flex;gap:10px;align-items:center}
.stationbar .stn{color:#8A978F;font-size:13px}
.mini{background:transparent;border:1px solid rgba(255,255,255,.2);color:#C7D2CB;border-radius:8px;padding:7px 13px;font-size:13px;font-weight:600}
.mini:hover{background:rgba(255,255,255,.06);color:#fff}
.stage{min-height:100vh;padding:52px 20px 20px;display:flex;align-items:center;justify-content:center}
.panel{background:var(--surface);border-radius:20px;width:100%;max-width:560px;padding:40px;box-shadow:0 24px 70px rgba(0,0,0,.35)}
.panel.wide{max-width:1100px;padding:36px 40px 40px}
.eyebrow{font-size:12.5px;font-weight:700;text-transform:uppercase;letter-spacing:.1em;color:var(--primary);margin-bottom:8px}
h2.big{font-size:30px;line-height:1.15;margin-bottom:6px}
.lead{color:var(--muted);font-size:16px;margin-bottom:26px}
.btn{display:inline-flex;align-items:center;justify-content:center;gap:9px;border:1px solid transparent;border-radius:12px;font-weight:600;transition:background .15s,border-color .15s,transform .2s ease,box-shadow .2s ease}
.btn-lg{width:100%;padding:17px;font-size:18px}
.btn-primary{background:var(--primary);color:#fff}
.btn-primary:hover{background:#174A38}
.btn-primary:disabled{opacity:.55;cursor:not-allowed}
.btn-ghost{background:var(--surface);border-color:var(--border);color:var(--ink)}
.btn-ghost:hover{background:var(--bg)}
.btn-row{display:flex;gap:12px;margin-top:8px}
.btn-row .btn{flex:1}
label.fl{display:block;font-weight:600;font-size:14px;margin-bottom:8px}
.bigin{width:100%;padding:18px;border:2px solid var(--border);border-radius:14px;font-size:26px;font-family:var(--font-display);font-weight:600;letter-spacing:.06em;text-align:center;color:var(--ink);text-transform:uppercase;box-sizing:border-box}
.bigin:focus{outline:none;border-color:var(--primary);box-shadow:0 0 0 4px var(--ok-soft)}
.helper{text-align:center;color:var(--muted);font-size:13.5px;margin-top:14px}
.helper button.linkish{background:none;border:none;color:var(--primary);font-weight:600;padding:0;font-size:inherit}
.armfield{margin-bottom:16px}
.armfield label{display:block;font-weight:600;font-size:14px;margin-bottom:7px}
.armfield select,.armfield input{width:100%;padding:13px 14px;border:1px solid var(--border);border-radius:11px;font:inherit;font-size:15px;background:var(--surface);box-sizing:border-box}
.armfield select:focus,.armfield input:focus{outline:none;border-color:var(--primary);box-shadow:0 0 0 3px var(--ok-soft)}
.lock{display:inline-flex;gap:8px;align-items:center;font-size:12.5px;color:var(--muted);margin-top:6px}
.idcard{display:flex;gap:18px;align-items:center;background:var(--bg);border:1px solid var(--border);border-radius:16px;padding:20px;margin-bottom:24px}
.idcard .ava{width:78px;height:78px;border-radius:50%;background:var(--primary);color:#fff;display:flex;align-items:center;justify-content:center;font-family:var(--font-display);font-weight:700;font-size:28px;flex:none;overflow:hidden}
.idcard .ava img{width:100%;height:100%;object-fit:cover}
.idcard .who h3{font-size:22px;margin-bottom:3px}
.idcard .who .meta{color:var(--muted);font-size:14.5px}
.idcard .who .mid{font-family:var(--font-display);font-weight:600;color:var(--ink);font-size:13.5px;margin-top:6px;letter-spacing:.04em}
.race{margin-bottom:12px}
.race h3{font-size:22px;margin-bottom:4px;letter-spacing:-.02em}
.race .sub{color:var(--muted);font-size:13.5px;margin-bottom:16px}
.progress-wrap{display:flex;align-items:center;justify-content:space-between;gap:12px;margin-bottom:18px}
.progress-label{font-size:13px;font-weight:600;color:var(--muted);letter-spacing:.02em}
.progress-dots{display:flex;gap:7px;align-items:center;flex-wrap:wrap;justify-content:flex-end}
.progress-dots span{
  width:8px;height:8px;border-radius:50%;background:#D5DDD8;
  transition:background .2s,transform .2s;
}
.progress-dots span.on{background:var(--primary);transform:scale(1.15)}
.progress-dots span.done{background:#8AA897}
.cand-row{
  display:flex;gap:18px;overflow-x:auto;padding:6px 4px 14px;scroll-snap-type:x mandatory;
  -webkit-overflow-scrolling:touch;scrollbar-width:thin;
}
.cand-row::-webkit-scrollbar{height:6px}
.cand-row::-webkit-scrollbar-thumb{background:#C5D0C9;border-radius:99px}
.cand{
  flex:0 0 min(220px, 72vw);scroll-snap-align:start;
  display:flex;flex-direction:column;align-items:stretch;text-align:left;
  background:var(--surface);border:1.5px solid var(--border);border-radius:18px;
  padding:0;overflow:hidden;position:relative;
  transition:transform .22s ease, border-color .22s ease, box-shadow .22s ease;
  box-shadow:0 1px 2px rgba(20,38,31,.04);
}
.cand:hover{
  transform:translateY(-4px);
  border-color:#B7C9BF;
  box-shadow:0 14px 28px rgba(20,38,31,.10);
}
.cand:hover .cand-photo img{transform:scale(1.04)}
.cand.sel{
  border-color:var(--primary);
  box-shadow:0 0 0 3px var(--ok-soft), 0 12px 26px rgba(30,92,70,.12);
  background:var(--surface);
}
.cand.sel:hover{transform:translateY(-4px)}
.cand-photo{
  position:relative;width:100%;aspect-ratio:3/4;background:linear-gradient(160deg,#D8E2DC 0%,#B8C8BF 100%);
  overflow:hidden;display:flex;align-items:center;justify-content:center;
}
.cand-photo img{
  width:100%;height:100%;object-fit:cover;object-position:center top;
  transition:transform .35s ease;display:block;
}
.cand-photo .initials{
  font-family:var(--font-display);font-weight:700;font-size:42px;color:#3C4A44;letter-spacing:.02em;
}
.cand-body{padding:14px 14px 16px;display:flex;flex-direction:column;gap:4px;min-height:88px}
.cand-body b{font-size:15.5px;line-height:1.25;color:var(--ink);font-weight:700}
.cand-body small{color:var(--muted);font-size:12.5px;line-height:1.35}
.cand .tick{
  position:absolute;top:12px;right:12px;z-index:2;
  width:28px;height:28px;border-radius:50%;border:2px solid rgba(255,255,255,.85);
  background:rgba(255,255,255,.72);backdrop-filter:blur(4px);
  display:flex;align-items:center;justify-content:center;color:transparent;
  font-size:14px;font-weight:700;transition:background .2s,border-color .2s,color .2s,transform .2s;
}
.cand.sel .tick{
  background:var(--primary);border-color:var(--primary);color:#fff;transform:scale(1.05);
}
@media (min-width:900px){
  .cand{flex:1 1 0;min-width:180px;max-width:240px}
  .cand-row{overflow-x:visible;flex-wrap:wrap}
}
@media (prefers-reduced-motion:reduce){
  .cand,.cand:hover,.cand-photo img{transition:none!important;transform:none!important}
}
.rev{border:1px solid var(--border);border-radius:14px;overflow:hidden;margin-bottom:24px}
.rev .row{display:flex;justify-content:space-between;padding:15px 18px;border-bottom:1px solid var(--border);font-size:15px}
.rev .row:last-child{border-bottom:none}
.rev .row .r-race{color:var(--muted)}
.rev .row .r-pick{font-weight:600}
.success{text-align:center}
.check{width:96px;height:96px;border-radius:50%;background:var(--ok-soft);display:flex;align-items:center;justify-content:center;margin:0 auto 22px}
.success h2{font-size:30px;margin-bottom:8px}
.countdown{margin-top:26px;color:var(--muted);font-size:14px}
.countdown b{color:var(--ink)}
.emailnote{display:inline-flex;gap:8px;align-items:center;background:var(--bg);border:1px solid var(--border);border-radius:99px;padding:8px 15px;font-size:13.5px;color:var(--muted);margin-top:18px}
.errbox{text-align:center}
.errbox .ic{width:80px;height:80px;border-radius:50%;display:flex;align-items:center;justify-content:center;margin:0 auto 20px;font-size:34px}
.errbox.notfound .ic{background:var(--accent-soft);color:#8A6415}
.errbox.voted .ic{background:var(--danger-soft);color:var(--danger)}
.errbox h2{font-size:26px;margin-bottom:8px}
.errbox p{color:var(--muted);font-size:15.5px;margin-bottom:24px}
.voted-detail{background:var(--bg);border:1px solid var(--border);border-radius:12px;padding:14px 18px;font-size:14px;margin-bottom:22px;text-align:left;color:var(--muted)}
.voted-detail b{color:var(--ink)}
.err{color:var(--danger);font-size:14px;margin-top:10px}
.recovery-list{list-style:none;padding:0;margin:0 0 16px}
.recovery-list li{border:1px solid var(--border);border-radius:12px;padding:12px 14px;margin-bottom:8px;display:flex;justify-content:space-between;gap:12px;align-items:center}
.recovery-list button.pick{background:var(--primary);color:#fff;border:none;border-radius:8px;padding:8px 12px;font-weight:600}
`;

function formatVotedAt(iso) {
  if (!iso) return '';
  try {
    return new Date(iso).toLocaleString();
  } catch {
    return String(iso);
  }
}

function loadMeta() {
  try {
    return JSON.parse(sessionStorage.getItem(META_KEY) || 'null');
  } catch {
    return null;
  }
}

function CandidateCard({ candidate, selected, onSelect }) {
  const [src, setSrc] = useState(null);
  const initials = `${(candidate.first_name || ' ')[0]}${(candidate.last_name || ' ')[0]}`.toUpperCase();

  useEffect(() => {
    let revoked = false;
    let url = null;
    if (!candidate.photo && !candidate.member_id) return undefined;
    (async () => {
      try {
        const res = await api.get(
          `/kiosk/candidates/${encodeURIComponent(candidate.member_id)}/photo`,
          { responseType: 'blob' }
        );
        url = URL.createObjectURL(res.data);
        if (!revoked) setSrc(url);
      } catch {
        if (!revoked) setSrc(null);
      }
    })();
    return () => {
      revoked = true;
      if (url) URL.revokeObjectURL(url);
    };
  }, [candidate.member_id, candidate.photo]);

  return (
    <button
      type="button"
      className={`cand${selected ? ' sel' : ''}`}
      onClick={onSelect}
      aria-pressed={selected}
    >
      <span className="tick" aria-hidden>
        ✓
      </span>
      <span className="cand-photo">
        {src ? <img src={src} alt="" /> : <span className="initials">{initials}</span>}
      </span>
      <span className="cand-body">
        <b>{candidate.display_name}</b>
        <small>{candidate.constituency || candidate.region || ' '}</small>
      </span>
    </button>
  );
}

export default function KioskVoting() {
  const [step, setStep] = useState('arm');
  const [elections, setElections] = useState([]);
  const [armForm, setArmForm] = useState({
    election_id: '',
    station_name: 'Station 1',
    poll_worker_label: '',
    passcode: '',
  });
  const [meta, setMeta] = useState(loadMeta);
  const [catalog, setCatalog] = useState([]);
  const [memberIdInput, setMemberIdInput] = useState('');
  const [member, setMember] = useState(null);
  const [picks, setPicks] = useState({});
  const [raceIndex, setRaceIndex] = useState(0);
  const [idempotencyKey, setIdempotencyKey] = useState(null);
  const [already, setAlready] = useState(null);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const [countdown, setCountdown] = useState(5);
  const [emailQueued, setEmailQueued] = useState(false);
  const [recoveryOpen, setRecoveryOpen] = useState(false);
  const [recoveryQ, setRecoveryQ] = useState('');
  const [recoveryHits, setRecoveryHits] = useState([]);
  const idRef = useRef(null);
  const timers = useRef({ cd: null, reset: null });

  const clearTimers = () => {
    clearInterval(timers.current.cd);
    clearTimeout(timers.current.reset);
  };

  const persistSession = (token, nextMeta, ballotCatalog) => {
    sessionStorage.setItem(TOKEN_KEY, token);
    sessionStorage.setItem(META_KEY, JSON.stringify(nextMeta));
    setMeta(nextMeta);
    setCatalog(ballotCatalog || []);
  };

  const clearSession = () => {
    sessionStorage.removeItem(TOKEN_KEY);
    sessionStorage.removeItem(META_KEY);
    setMeta(null);
    setCatalog([]);
  };

  const resetVoter = useCallback(() => {
    clearTimers();
    setMember(null);
    setPicks({});
    setRaceIndex(0);
    setIdempotencyKey(crypto.randomUUID());
    setAlready(null);
    setError('');
    setMemberIdInput('');
    setRecoveryOpen(false);
    setRecoveryHits([]);
    setStep('id');
    setTimeout(() => idRef.current?.focus(), 50);
  }, []);

  useEffect(() => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href =
      'https://fonts.googleapis.com/css2?family=Archivo:wght@500;600;700&family=Inter:wght@400;500;600&display=swap';
    document.head.appendChild(link);
    return () => {
      document.head.removeChild(link);
      clearTimers();
    };
  }, []);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const token = sessionStorage.getItem(TOKEN_KEY);
      if (!token) {
        try {
          const res = await api.get('/kiosk/elections');
          if (!cancelled) setElections(res.data?.data || []);
        } catch {
          if (!cancelled) setElections([]);
        }
        return;
      }
      try {
        const res = await api.get('/kiosk/session');
        if (cancelled) return;
        const d = res.data?.data;
        persistSession(token, {
          election_id: d.election.id,
          election_name: d.election.name,
          station_name: d.station_name,
          poll_worker_label: d.poll_worker_label,
        }, d.ballot_catalog);
        resetVoter();
      } catch {
        clearSession();
        setStep('arm');
        try {
          const res = await api.get('/kiosk/elections');
          if (!cancelled) setElections(res.data?.data || []);
        } catch {
          if (!cancelled) setElections([]);
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [resetVoter]);

  const startSession = async (e) => {
    e?.preventDefault?.();
    setError('');
    setBusy(true);
    try {
      const res = await api.post('/kiosk/arm', {
        election_id: Number(armForm.election_id) || armForm.election_id,
        station_name: armForm.station_name,
        poll_worker_label: armForm.poll_worker_label,
        passcode: armForm.passcode,
      });
      const d = res.data?.data;
      persistSession(
        d.station_token,
        {
          election_id: d.election.id,
          election_name: d.election.name,
          station_name: d.station_name,
          poll_worker_label: d.poll_worker_label,
        },
        d.ballot_catalog
      );
      if (d.warning) {
        setError(d.warning);
      }
      if (!d.ballot_catalog?.length) {
        setError(
          d.warning ||
            'No candidates on this ballot. Add candidates in HR → Elections before voting.'
        );
      }
      resetVoter();
      if (d.warning || !d.ballot_catalog?.length) {
        // resetVoter clears error — restore warning for the arm screen if we bounced back
        // Stay armed; show warning on ID screen via helper note
        setTimeout(() => {
          setError(
            d.warning ||
              'No candidates on this ballot. Add candidates in HR → Elections before voting.'
          );
        }, 0);
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Could not arm station');
    } finally {
      setBusy(false);
    }
  };

  const endSession = async () => {
    try {
      await api.post('/kiosk/disarm');
    } catch {
      /* ignore */
    }
    clearSession();
    clearTimers();
    setStep('arm');
    setError('');
    try {
      const res = await api.get('/kiosk/elections');
      setElections(res.data?.data || []);
    } catch {
      setElections([]);
    }
  };

  const showAlready = (payload) => {
    setAlready({
      name: payload.member?.display_name || payload.member?.name,
      member_id: payload.member?.member_id,
      station: payload.turnout?.station_name,
      time: formatVotedAt(payload.turnout?.voted_at),
    });
    setStep('voted');
  };

  const lookup = async () => {
    setError('');
    const id = memberIdInput.trim();
    if (!id) return;
    setBusy(true);
    try {
      const res = await api.post('/kiosk/lookup', { id_card_number: id });
      const data = res.data;
      if (data.status === 'not_found') {
        setStep('notfound');
        return;
      }
      if (data.status === 'already_voted') {
        showAlready(data);
        return;
      }
      setMember(data.member);
      setIdempotencyKey(crypto.randomUUID());
      setPicks({});
      setStep('confirm');
    } catch (err) {
      setError(err.response?.data?.message || 'Lookup failed');
    } finally {
      setBusy(false);
    }
  };

  const runRecovery = async () => {
    setError('');
    setBusy(true);
    try {
      const res = await api.post('/kiosk/lookup-recovery', { q: recoveryQ });
      setRecoveryHits(res.data?.data || []);
    } catch (err) {
      setError(err.response?.data?.message || 'Search failed');
    } finally {
      setBusy(false);
    }
  };

  const selectRecovery = (hit) => {
    if (hit.already_voted) {
      showAlready({
        member: hit,
        turnout: hit.turnout,
      });
      return;
    }
    if (!hit.eligible) {
      setError('This member is not eligible to vote');
      return;
    }
    setMember(hit);
    setIdempotencyKey(crypto.randomUUID());
    setPicks({});
    setRecoveryOpen(false);
    setStep('confirm');
  };

  const [photoObjectUrl, setPhotoObjectUrl] = useState(null);

  useEffect(() => {
    let revoked = false;
    let url = null;
    (async () => {
      if (!member?.has_photo || !member?.id) {
        setPhotoObjectUrl(null);
        return;
      }
      try {
        const res = await api.get(`/kiosk/members/${encodeURIComponent(member.id)}/photo`, {
          responseType: 'blob',
        });
        url = URL.createObjectURL(res.data);
        if (!revoked) setPhotoObjectUrl(url);
      } catch {
        if (!revoked) setPhotoObjectUrl(null);
      }
    })();
    return () => {
      revoked = true;
      if (url) URL.revokeObjectURL(url);
    };
  }, [member?.id, member?.has_photo]);

  const startBallot = () => {
    setError('');
    setRaceIndex(0);
    setPicks({});
    setStep('ballot');
  };

  const goNextRace = () => {
    const race = catalog[raceIndex];
    if (!race) return;
    if (!picks[race.id]) {
      setError(`Please select a candidate for ${race.name}.`);
      return;
    }
    setError('');
    if (raceIndex >= catalog.length - 1) {
      setStep('review');
      return;
    }
    setRaceIndex((i) => i + 1);
  };

  const goPrevRace = () => {
    setError('');
    if (raceIndex <= 0) {
      setStep('confirm');
      return;
    }
    setRaceIndex((i) => i - 1);
  };

  const submitVote = async () => {
    setError('');
    setBusy(true);
    try {
      const choices = catalog.map((race) => ({
        position_id: race.id,
        candidate_member_id: picks[race.id],
        vote_type: 'candidate',
      }));
      const res = await api.post('/kiosk/vote', {
        member_id: member.id,
        idempotency_key: idempotencyKey,
        choices,
      });
      setEmailQueued(!!res.data?.data?.email_queued);
      setStep('success');
      let n = 5;
      setCountdown(n);
      clearTimers();
      timers.current.cd = setInterval(() => {
        n -= 1;
        setCountdown(n);
        if (n <= 0) clearInterval(timers.current.cd);
      }, 1000);
      timers.current.reset = setTimeout(resetVoter, 5000);
    } catch (err) {
      const data = err.response?.data;
      if (data?.code === 'already_voted' || data?.status === 'already_voted') {
        showAlready(data);
      } else {
        setError(data?.message || 'Failed to submit vote');
      }
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="kiosk-root">
      <style>{styles}</style>
      {meta && (
        <div className="stationbar">
          <span className="wm">
            ATU<span>·</span>TEIN
          </span>
          <span className="pill">
            <span className="dot" />
            Voting open
          </span>
          <span className="stn">{meta.election_name}</span>
          <div className="right">
            <span className="stn">
              {meta.station_name}
              {meta.poll_worker_label ? ` · ${meta.poll_worker_label}` : ''}
            </span>
            <button type="button" className="mini" onClick={resetVoter}>
              Next voter →
            </button>
            <button type="button" className="mini" onClick={endSession}>
              End session
            </button>
          </div>
        </div>
      )}

      <div className="stage">
        {step === 'arm' && (
          <form className="panel" onSubmit={startSession}>
            <div className="eyebrow">Polling station setup</div>
            <h2 className="big">Open this station for voting</h2>
            <p className="lead">A staff member sets this up once per station, at the start of the day.</p>
            <div className="armfield">
              <label htmlFor="election">Election</label>
              <select
                id="election"
                value={armForm.election_id}
                onChange={(e) => setArmForm((f) => ({ ...f, election_id: e.target.value }))}
                required
              >
                <option value="">Select election…</option>
                {elections.map((el) => (
                  <option key={el.id} value={el.id}>
                    {el.name}
                  </option>
                ))}
              </select>
              {elections.length === 0 && (
                <span className="lock">No kiosk-enabled active elections. Set a station passcode in HR → Elections first.</span>
              )}
            </div>
            <div className="armfield">
              <label htmlFor="station">Station name</label>
              <input
                id="station"
                value={armForm.station_name}
                onChange={(e) => setArmForm((f) => ({ ...f, station_name: e.target.value }))}
                required
              />
            </div>
            <div className="armfield">
              <label htmlFor="worker">Poll worker</label>
              <input
                id="worker"
                value={armForm.poll_worker_label}
                onChange={(e) => setArmForm((f) => ({ ...f, poll_worker_label: e.target.value }))}
                placeholder="Optional"
              />
            </div>
            <div className="armfield">
              <label htmlFor="pass">Station passcode</label>
              <input
                id="pass"
                type="password"
                value={armForm.passcode}
                onChange={(e) => setArmForm((f) => ({ ...f, passcode: e.target.value }))}
                required
                autoComplete="off"
              />
              <span className="lock">Prevents the public voting URL from being used off-site.</span>
            </div>
            {error && <p className="err">{error}</p>}
            <button className="btn btn-primary btn-lg" style={{ marginTop: 8 }} type="submit" disabled={busy || !elections.length}>
              {busy ? 'Starting…' : 'Start voting session'}
            </button>
          </form>
        )}

        {step === 'id' && (
          <div className="panel">
            <div className="eyebrow">Step 1 of 3 · Identify</div>
            <h2 className="big">Enter your Member ID</h2>
            <p className="lead">Type the ID on your membership card, or scan the card.</p>
            <label className="fl" htmlFor="idin">
              Member ID
            </label>
            <input
              ref={idRef}
              className="bigin"
              id="idin"
              value={memberIdInput}
              onChange={(e) => setMemberIdInput(e.target.value.toUpperCase())}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                  lookup();
                }
              }}
              placeholder="ASH00000000"
              autoComplete="off"
              autoFocus
            />
            <div className="btn-row" style={{ marginTop: 20 }}>
              <button type="button" className="btn btn-ghost btn-lg" onClick={resetVoter}>
                Clear
              </button>
              <button type="button" className="btn btn-primary btn-lg" onClick={lookup} disabled={busy}>
                Continue
              </button>
            </div>
            {error && <p className="err">{error}</p>}
            <p className="helper">
              Can&apos;t find your card?{' '}
              <button type="button" className="linkish" onClick={() => setRecoveryOpen(true)}>
                Poll worker: search by name
              </button>
            </p>
            {recoveryOpen && (
              <div style={{ marginTop: 20 }}>
                <label className="fl" htmlFor="rec">
                  Name or phone
                </label>
                <input
                  id="rec"
                  value={recoveryQ}
                  onChange={(e) => setRecoveryQ(e.target.value)}
                  onKeyDown={(e) => e.key === 'Enter' && runRecovery()}
                  style={{ width: '100%', padding: 12, borderRadius: 10, border: '1px solid var(--border)', boxSizing: 'border-box' }}
                />
                <button type="button" className="btn btn-primary btn-lg" style={{ marginTop: 10 }} onClick={runRecovery} disabled={busy}>
                  Search
                </button>
                <ul className="recovery-list" style={{ marginTop: 14 }}>
                  {recoveryHits.map((h) => (
                    <li key={h.id}>
                      <div>
                        <b>{h.display_name}</b>
                        <div style={{ fontSize: 13, color: 'var(--muted)' }}>
                          {h.member_id} · {h.constituency || '—'}
                          {h.already_voted ? ' · already voted' : ''}
                        </div>
                      </div>
                      <button type="button" className="pick" onClick={() => selectRecovery(h)}>
                        Select
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        )}

        {step === 'confirm' && member && (
          <div className="panel">
            <div className="eyebrow">Step 1 of 3 · Confirm it&apos;s you</div>
            <h2 className="big">Is this you?</h2>
            <p className="lead">Please check the details match before voting.</p>
            <div className="idcard">
              <div className="ava">
                {photoObjectUrl ? <img src={photoObjectUrl} alt="" /> : member.initials}
              </div>
              <div className="who">
                <h3>{member.display_name}</h3>
                <div className="meta">
                  Constituency: {member.constituency || '—'}
                  {member.gender ? ` · ${member.gender}` : ''}
                </div>
                <div className="mid">{member.member_id || member.association_number}</div>
              </div>
            </div>
            <div className="btn-row">
              <button type="button" className="btn btn-ghost btn-lg" onClick={resetVoter}>
                No, go back
              </button>
              <button
                type="button"
                className="btn btn-primary btn-lg"
                onClick={startBallot}
              >
                Yes, that&apos;s me
              </button>
            </div>
          </div>
        )}

        {step === 'ballot' && (() => {
          const race = catalog[raceIndex];
          const total = catalog.length;
          const isLast = raceIndex >= total - 1;
          if (!race) {
            return (
              <div className="panel wide">
                <div className="eyebrow">Ballot not ready</div>
                <h2 className="big">No candidates to vote for</h2>
                <p className="lead" style={{ marginBottom: 16 }}>
                  This election is active, but the kiosk has no races with candidates. In HR → Elections,
                  open this election, click Manage Candidates, and add at least one candidate for each
                  position. Then end this station session and arm again.
                </p>
                {error && <p className="err">{error}</p>}
                <div className="btn-row">
                  <button type="button" className="btn btn-ghost btn-lg" onClick={resetVoter}>
                    Back
                  </button>
                  <button type="button" className="btn btn-primary btn-lg" onClick={endSession}>
                    End session
                  </button>
                </div>
              </div>
            );
          }
          return (
            <div className="panel wide">
              <div className="eyebrow">
                Step 2 of 3 · Vote · Position {raceIndex + 1} of {total}
              </div>
              <div className="progress-wrap">
                <span className="progress-label">Choose one, then continue</span>
                <div className="progress-dots" aria-hidden>
                  {catalog.map((r, i) => (
                    <span
                      key={r.id}
                      className={i === raceIndex ? 'on' : picks[r.id] ? 'done' : ''}
                    />
                  ))}
                </div>
              </div>
              <div className="race">
                <h3>{race.name}</h3>
                <div className="sub">Select one</div>
                <div className="cand-row">
                  {race.candidates.map((c) => (
                    <CandidateCard
                      key={c.member_id}
                      candidate={c}
                      selected={picks[race.id] === c.member_id}
                      onSelect={() => {
                        setError('');
                        setPicks((p) => ({ ...p, [race.id]: c.member_id }));
                      }}
                    />
                  ))}
                </div>
              </div>
              {error && <p className="err">{error}</p>}
              <div className="btn-row">
                <button type="button" className="btn btn-ghost btn-lg" onClick={goPrevRace}>
                  {raceIndex === 0 ? 'Back' : 'Previous'}
                </button>
                <button
                  type="button"
                  className="btn btn-primary btn-lg"
                  onClick={goNextRace}
                  disabled={!picks[race.id]}
                >
                  {isLast ? 'Review & submit' : 'Next'}
                </button>
              </div>
            </div>
          );
        })()}

        {step === 'review' && (
          <div className="panel">
            <div className="eyebrow">Step 3 of 3 · Confirm</div>
            <h2 className="big">Confirm your vote</h2>
            <p className="lead">Once you submit, your vote is final and can&apos;t be changed.</p>
            <div className="rev">
              {catalog.map((race) => {
                const cand = race.candidates.find((c) => c.member_id === picks[race.id]);
                return (
                  <div className="row" key={race.id}>
                    <span className="r-race">{race.name}</span>
                    <span className="r-pick">{cand?.display_name || '—'}</span>
                  </div>
                );
              })}
            </div>
            {error && <p className="err">{error}</p>}
            <div className="btn-row">
              <button
                type="button"
                className="btn btn-ghost btn-lg"
                onClick={() => {
                  setError('');
                  setRaceIndex(Math.max(0, catalog.length - 1));
                  setStep('ballot');
                }}
              >
                Change
              </button>
              <button type="button" className="btn btn-primary btn-lg" onClick={submitVote} disabled={busy}>
                {busy ? 'Submitting…' : 'Submit vote'}
              </button>
            </div>
          </div>
        )}

        {step === 'success' && (
          <div className="panel">
            <div className="success">
              <div className="check">
                <svg viewBox="0 0 24 24" width="48" height="48" fill="none" stroke="var(--primary)" strokeWidth="2.5">
                  <path d="M20 6 9 17l-5-5" />
                </svg>
              </div>
              <h2>Thank you, your vote is recorded.</h2>
              <p className="lead" style={{ marginBottom: 0 }}>
                You may now leave the station.
              </p>
              {emailQueued && <div className="emailnote">A confirmation email is on its way to you.</div>}
              <div className="countdown">
                Ready for the next voter in <b>{countdown}</b>s ·{' '}
                <button type="button" className="linkish" onClick={resetVoter} style={{ color: 'var(--primary)', fontWeight: 600, background: 'none', border: 'none' }}>
                  Next voter now
                </button>
              </div>
            </div>
          </div>
        )}

        {step === 'notfound' && (
          <div className="panel">
            <div className="errbox notfound">
              <div className="ic">?</div>
              <h2>ID not found</h2>
              <p>We couldn&apos;t find a member with that ID. Please check the card and try again, or ask the poll worker for help.</p>
              <div className="btn-row">
                <button
                  type="button"
                  className="btn btn-ghost btn-lg"
                  onClick={() => {
                    setRecoveryOpen(true);
                    setStep('id');
                  }}
                >
                  Search by name
                </button>
                <button type="button" className="btn btn-primary btn-lg" onClick={() => setStep('id')}>
                  Try again
                </button>
              </div>
            </div>
          </div>
        )}

        {step === 'voted' && already && (
          <div className="panel">
            <div className="errbox voted">
              <div className="ic">✓</div>
              <h2>Already voted</h2>
              <p>Our records show this member has already cast a vote in this election.</p>
              <div className="voted-detail">
                <b>{already.name}</b>
                {already.member_id ? ` · ${already.member_id}` : ''}
                <br />
                Voted at {already.station || 'another station'}
                {already.time ? ` · ${already.time}` : ''}
              </div>
              <button type="button" className="btn btn-primary btn-lg" onClick={resetVoter}>
                Next voter
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
